import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

//assets
import defaultAvatar from '../../assets/img/default-avatar.svg'

//styles
import styles from './Avatar.module.scss'

const Avatar = ({ className, src, alt, ...restProps }) => {
  return (
    <div className={classnames(styles.root, className)} {...restProps}>
      <img src={src || defaultAvatar} alt={alt} className={styles.img} />
    </div>
  )
}

Avatar.propTypes = {
  alt: PropTypes.string,
  src: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
}

Avatar.defaultProps = {
  alt: 'avatar',
}

export default Avatar
